import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const ConfiguringCloudTrailPhase = memo(function ConfiguringCloudTrailPhase({
  disabled,
  progressIcon,
  successIcon,
  errorIcon,
}: ConfiguringCloudTrailPhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">Configuring CloudTrail...</Typography>
      </Box>
      <Stack sx={{ mt: 2 }} spacing={1} direction="column">
        <Typography variant="body1">
          We configure{" "}
          <a
            href="https://aws.amazon.com/cloudtrail/"
            target="_blank"
            rel="noopener noreferrer"
          >
            AWS CloudTrail audit logs
          </a>{" "}
          in your account to provide real-time security detections.
        </Typography>

        <Typography variant="body1">
          To minimize your operating costs, this can be a little complicated on
          our part! For details, feel free to reference{" "}
          <a href="https://docs.threatkey.com/article/10-aws">
            our technical documentation
          </a>
          .
        </Typography>
      </Stack>
    </ServiceConnectionStep>
  );
});

export default ConfiguringCloudTrailPhase;

// -----------------------------------------------------------------------------

interface ConfiguringCloudTrailPhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
